import React from 'react';
import { List } from '@mui/material';

import { AuthCompanyContext, useHasRole } from '@homesusa/auth';
import { AppContext } from '../../contexts';
import { SubMenu } from './submenu.component';

export function Sidebar(): JSX.Element {
  const {
    appState: {
      layout: {
        sidebar: { items }
      }
    }
  } = React.useContext(AppContext);
  const { currentEmployee } = React.useContext(AuthCompanyContext);
  const { hasUserRole } = useHasRole();

  const visibleItems = React.useMemo(() => {
    const filteredItems = Object.entries(items).filter(([_, item]) => {
      const itemAllowedForEmployee =
        currentEmployee == null ||
        item.allowedEmployeeRoles == null ||
        item.allowedEmployeeRoles.length === 0 ||
        item.allowedEmployeeRoles.includes(currentEmployee.roleName);
      const itemExcludedForUser =
        item.excludeUserRoles != null &&
        item.excludeUserRoles.length !== 0 &&
        hasUserRole(item.excludeUserRoles);
      return itemAllowedForEmployee && !itemExcludedForUser;
    });

    return Object.fromEntries(filteredItems);
  }, [items, currentEmployee, hasUserRole]);

  return (
    <List component='nav'>
      {Object.entries(visibleItems).map(([key, item]) => (
        <SubMenu key={key} {...item} />
      ))}
    </List>
  );
}
